module.exports = __webpack_public_path__ + "img/layout_bottom_2.ea7125ab.png";